module.exports = {"this_week":"This week","last_7_days":"Last 7 days","last_30_days":"Last 30 days","this_month":"This month","last_month":"Last month","this_year":"This year","last_year":"Last year"}


//////////////////
// WEBPACK FOOTER
// ./src/vue-ctk-date-time-picker/_subs/_subs/CtkCalendarShortcut/_subs/shortcutsTranslation.json
// module id = 37
// module chunks = 0